<template>
  <div class="section-wrapper classroom">
    <div v-if="notificationPanel" class="notificationPanel">
      <i
        class="fas fa-times-circle"
        style="float:right"
        @click="notificationPanel = false"
      />
      <div
        v-for="(notification, index) in notifications"
        :key="`notification-${index}`"
      >
        <p
          v-for="(message, j) in notification.data.messages"
          :key="`message-${j}`"
        >
          {{ message }}
        </p>
      </div>
    </div>
    <div class="topSubActions">
      <van-button type="info" @click="notificationPanel = true">
        {{ $t("notifications") }}
      </van-button>
      <van-button
        type="info"
        @click="showClassroomDetailsForm = true"
        v-if="isAdmin"
      >
        {{ $t("edit classroom") }}
      </van-button>
      <van-button type="info" @click="showAddBox = true" v-if="isAdmin">
        {{ $t("add box") }}
      </van-button>
      <van-button type="danger" v-if="isAdmin" @click="submitDeleteClassroom">
        {{ $t("delete") }}
      </van-button>
    </div>
    <van-skeleton title :row="5" v-if="classroom.loading" />
    <Tiles :items="boxes" tileType="box" />
    <MembersStatList
      v-if="
        isAdmin &&
          classroomData &&
          studentsData &&
          studentsData.results &&
          studentsData.results.length > 0
      "
      :boxStateStats="classroomData.box_state_stats"
      :quizResultStats="classroomData.quiz_result_stats"
      :students="studentsData.results"
      :classroom="classroom.data.id"
    />

    <van-action-sheet
      v-model="showClassroomDetailsForm"
      :title="$t('edit classroom')"
      :round="false"
      :cancel-text="$t('cancel')"
    >
      <ClassroomDetailsForm
        v-if="showClassroomDetailsForm"
        :classroom="classroom.data"
        @closeEdit="closeEdit"
      />
    </van-action-sheet>
    <van-action-sheet
      v-model="showAddBox"
      :round="false"
      :cancel-text="$t('cancel')"
    >
      <div class="content">
        <BoxDetailsForm
          v-if="showAddBox"
          @closeEdit="closeEdit"
          :classroom="classroom.data"
        />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ClassroomDetailsForm from "@/components/classrooms/ClassroomDetailsForm";
import MembersStatList from "@/components/classrooms/MembersStatList";
import BoxDetailsForm from "@/components/box/BoxDetailsForm";
import Tiles from "@/components/Tiles";
export default {
  name: "Classroom",
  components: { Tiles, ClassroomDetailsForm, BoxDetailsForm, MembersStatList },
  computed: {
    ...mapState("vokabel", ["classroom", "students"]),
    ...mapState("account", ["user"]),
    isAdmin() {
      if (this.classroomData && this.classroomData.admins) {
        return this.classroomData.admins.includes(this.user.id);
      }
      return false;
    },
    classroomData() {
      const { classroom } = this;
      return classroom.data ? classroom.data : {};
    },
    studentsData() {
      const { students } = this;
      return students.data ? students.data : [];
    },
    boxes() {
      return this.classroomData && this.classroomData.boxes_list
        ? this.classroomData.boxes_list
        : [];
    },
    notifications() {
      return this.classroomData && this.classroomData.notifications
        ? this.classroomData.notifications
        : [];
    }
  },
  data() {
    return {
      notificationPanel: false,
      showClassroomDetailsForm: false,
      showAddBox: false
    };
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("vokabel", [
      "getClassroom",
      "deleteClassroom",
      "getStudentsActivity"
    ]),
    getDataSetTitle() {
      this.getClassroom(this.$route.params.id).then(data => {
        this.SET_PAGE_TITLE(data.name);
      });
    },
    closeEdit() {
      this.showAddBox = false;
      this.showClassroomDetailsForm = false;
      this.getDataSetTitle();
    },
    imgsrc(image) {
      let baseStaticHost =
        process.env.NODE_ENV == "development"
          ? ""
          : "https://f002.backblazeb2.com/file/sprkr-user-uploads";

      return image ? `${baseStaticHost}/${image}` : "";
    },
    submitDeleteClassroom() {
      this.deleteClassroom(this.$route.params.id).then(() => {
        this.$router.push({ name: "my-classrooms" });
      });
    }
  },
  mounted() {
    this.SET_PAGE_TITLE("");
    this.getDataSetTitle();
    this.getStudentsActivity(this.$route.params.id);
  }
};
</script>

<style lang="scss">
.notificationPanel {
  padding: 10px;
  position: absolute;
  width: 100%;
  border-right: 1px solid #e3e3e3;
  top: 0;
  height: 100%;
  z-index: 100;
  background: white;
}
</style>
